/**
 * Every user-facing string lives here. Admin → Content can override any key
 * (stored in `copy_strings`); this file is the fallback.
 * Tokens: {first_name} {tickets} {rank} {leader_tickets} {avg_vip_tickets} {days_to_draw} {prize_name}
 */
export const en = {
  common: {
    testPrefix: '[TEST]',
  },
  bot: {
    videoFileId: 'Video file id for admin → Settings → Bot videos: {id}',
    mediaSaved: 'Saved to the media library ({kind}). Pick it in admin → Funnel → a step → Media.',
    adminLinked: 'Done: this Telegram is linked to your admin account. Go back to the admin panel.',
    adminLinkExpired: 'This link has expired. Press “Link Telegram” in the admin panel again.',
    welcome:
      'Hey {first_name}. You are one step from ticket #1 for the {prize_name}.\n\n1. Subscribe to the channel.\n2. Come back and press the button below.',
    subscribeButton: 'I subscribed ✓',
    openChannelButton: 'Open the channel',
    notSubscribed:
      "I can't see you in the channel yet. Subscribe, wait a few seconds and press the button again.",
    retryButton: 'Check again',
    ticketIssued:
      'Ticket #{ticket_code} is yours. You are in the draw for the {prize_name}.\n\nOpen the app to see your chance and collect more tickets.',
    openAppButton: 'Open app',
    openAppPrompt: 'Your tickets, your chance and the wheel are all in the app.',
    boostButton: 'Boost my chance ×4',
    checkFailed: "Telegram didn't let us check your subscription — try again in a minute.",
    menu: {
      openApp: 'Open App',
      myTickets: 'My tickets',
      getTickets: 'Get tickets',
      vip: 'VIP',
      support: 'Support',
    },
    myTickets: 'You have {tickets} tickets. Rank #{rank}. Draw in {days_to_draw} days.',
    getTickets:
      'Fastest tickets right now: VIP (+{vip_reward}), invite friends, daily tasks. Everything is in the app.',
    vipInfo:
      'VIP: daily signals, two live sessions a week, lessons and a private chat. Joining gives +{vip_reward} tickets and ×1.5 on everything after. Talk to Support to get in. Your code: REF-{ref} — if the chat opens empty, send this code to Support.',
    support:
      'Write to Support. Your code: REF-{ref} — if the chat opens empty, send it as your first message.',
    supportMissing: 'Support isn’t connected yet. Try again a little later.',
    supportButton: 'Write to Support',
    talkToSupport: 'Talk to Support',
    joinVipButton: 'Join VIP',
    alreadyIn:
      'You are in, {first_name}. Ticket #{ticket_code}, {tickets} tickets so far. Open the app to add more.',
    menuReady: 'Your menu is pinned below the chat.',
    myTicketsNone:
      'No tickets yet. Subscribe to the channel and press the button to get ticket #1.',
    tasksButton: 'See tasks',
    codeAccepted: 'Code accepted. +{n} tickets for {stream}.',
    codeWrong: 'That isn’t today’s code word. Rudy says it on air — listen for it and try again.',
    codeClosed:
      'The window for this stream has closed. Catch the next one live — the code works for 30 minutes.',
    codeAlready: 'You already have your tickets for this stream.',
    vipButton: 'About VIP',
  },
  push: {
    on_unsubscribe: 'Your channel ticket was removed. Rejoin the channel to restore it instantly.',
    on_resubscribe: 'Welcome back. Your channel ticket is restored.',
    on_vip_join: "You're in VIP. +{vip_reward} tickets.",
    on_vip_leave: 'You left VIP — your VIP tickets were removed. Rejoin anytime, the door is open.',
    on_vip_approved:
      'Support approved you for VIP. Tap the button to join — the link is yours alone.',
    on_wheel_open: "The wheel is open. One spin today — two if you're VIP.",
    on_wheel_reminder: "4 hours left on the wheel. You haven't spun yet.",
    on_rank_up_top100: "You're in the top 100. {rank} and climbing.",
    on_rank_lost_top100: 'You dropped out of the top 100. Two tickets put you back.',
    on_overtaken: "Someone from {rival_city} just passed you. +2 tickets and you're ahead again.",
    on_draw_commit: 'Fairness hash published: {hash}. Draw in 24 h.',
    on_draw_start: 'The draw is starting. Watch live and keep this chat open.',
    draw_channel_post:
      'Fairness hash for the {prize} draw: {hash}\n\nThe draw is on {when}. Right after it we publish the secret seed — anyone can recompute the winner and check it was fixed before the draw.',
    on_draw_winner_you: 'YOUR TICKET CAME UP. Press the button within 10 minutes.',
    on_draw_winner_button: "I'm here!",
    on_draw_confirmed: 'Confirmed. Support will contact you about the {prize} within 24 hours.',
    on_draw_too_late:
      'The 10 minutes have passed for this draw. Your tickets still count for the next one.',
    on_bonus_spin: 'Your ticket was a lucky one — a bonus wheel spin is yours.',
    on_wheel_streak: 'Four Saturdays in a row on the wheel. +{n} tickets.',
    on_prize_won: 'You won {prize} on the wheel. Fill in your address in the app and we ship it.',
    on_referral_joined: '{friend_name} joined with your link. +1 ticket.',
    on_secret_task: 'Secret task unlocked for 24 hours. Check Tasks.',
    friendFallback: 'A friend',
    on_task_approved: 'Approved: {task}. +{n} tickets.',
    on_task_rejected: '{task} wasn’t approved: {reason} Fix it and send it again from Tasks.',
    on_overtaken_nocity:
      "Someone just passed you on the leaderboard. +2 tickets and you're ahead again.",
    nameFallback: 'there',
    wheelButton: 'Spin the wheel',
    rankButton: 'See my rank',
  },
  /** Share card PNG (1080×1920 story image) and the texts sent with it. */
  share: {
    brand: 'Rudy Giveaway',
    kicker: 'I’m in the draw for the',
    ticket: 'ticket',
    tickets: 'tickets',
    rank: 'Rank #{rank}',
    scan: 'Scan to join — ticket #1 is free',
    storyText: 'I’m in the draw for the {prize}. Join with my link and get your first ticket.',
    messageText: 'I’m in the draw for the {prize}. Join with my link — your first ticket is free.',
  },
  /** Bridge page /go/<code> — ad traffic lands here before Telegram opens. */
  bridge: {
    brand: 'Rudy Giveaway',
    prizeLabel: 'This season Rudy gives away',
    title: 'Your first ticket is waiting in Telegram',
    body: 'Open the bot, subscribe to the channel and ticket #1 for the {prize} is yours. It takes ten seconds.',
    button: 'Open in Telegram',
    stuck: 'Telegram didn’t open?',
    ios: 'iPhone: tap ••• or the share icon at the top, choose “Open in Safari”, then tap the button again.',
    android: 'Android: tap ⋮ at the top, choose “Open in Chrome”, then tap the button again.',
  },
  season: {
    porsche: { name: 'Porsche Season', prize: 'Porsche Macan' },
  },
  tasks: {
    channel_subscribe: {
      title: 'Join the channel',
      description: 'Your first ticket. Stays with you across seasons.',
    },
    vip_join: {
      title: 'Enter VIP',
      description: '+{reward} tickets now and ×{vip_x} on everything you earn after.',
    },
    follow_instagram: {
      title: 'Follow on Instagram',
      description: 'Follow, screenshot your profile view, add your handle.',
    },
    follow_tiktok: {
      title: 'Follow on TikTok',
      description: 'Follow, screenshot your profile view, add your handle.',
    },
    repost_story: {
      title: 'Repost to your story',
      description: 'Public profile, story stays up 24 h. Screenshot it.',
    },
    stream_attend: {
      title: 'Catch the live stream',
      description: 'Rudy says a code word on air. You have 30 minutes to send it.',
    },
    daily_streak: { title: '7-day streak', description: 'Open the app seven days in a row.' },
    price_guess: {
      title: 'Call the price',
      description: 'Where will BTC be in one hour? Within 0.5 % wins.',
    },
    quiz: { title: 'Daily quiz', description: 'Five questions. One ticket per right answer.' },
    watch_video: {
      title: 'Watch the breakdown',
      description: 'Watch to the end — the timer runs on our side.',
    },
    comment: {
      title: 'Comment under posts',
      description: 'Up to three tickets a day for real comments.',
    },
    referral: {
      title: 'Bring a friend',
      description:
        '+{reward} when they get their first ticket, +{ref_vip} more when they join VIP.',
    },
    team_pool: {
      title: 'Build a team of four',
      description: 'You and three friends, each with 5+ tickets: +2 for everyone.',
    },
    secret_task: {
      title: 'Secret task',
      description: 'Unlocked by push only. Watch your notifications.',
    },
  },
  wheel: {
    sectors: {
      macbook: 'MacBook',
      iphone: 'iPhone',
      airpods: 'AirPods',
      ps5: 'PS5',
      cash50: '$50',
      cash100: '$100',
      cash200: '$200',
      tickets5: '+5 tickets',
      nothing: 'Next time',
    },
  },
  vipLessons: {
    l1: 'How a signal is built: entry, target, stop',
    l2: 'Position size: risk 1 % and sleep at night',
    l3: 'Reading the trend before you click',
    l4: 'When to stay out of the market',
    l5: 'Your first week of trading the signals',
  },
  actions: {
    manual: 'Manual adjustment',
    season_end: 'Season end burn',
    season_start_bonus: 'VIP season bonus',
    wheel_sector_tickets: 'Wheel prize: tickets',
    wheel_streak: 'Wheel streak',
    activity_lottery: 'Activity lottery',
    vip_lesson: 'VIP lesson',
    revoke: 'Revoked',
  },
  app: {
    title: 'Rudy Giveaway',
    loading: 'Starting the engine',
    participantFallback: 'Participant',
    testBadge: 'Test mode',
    tabs: {
      home: 'Garage',
      rank: 'Rank',
      tasks: 'Tasks',
      wheel: 'Wheel',
      support: 'Support',
      vip: 'VIP',
    },
    wheel: {
      title: 'Weekly wheel',
      openNow: 'Open until {time}',
      opensAt: 'Opens {day} at {time}',
      closed: 'The wheel is closed for this week.',
      spinsLeft: '{n} spins left',
      spinLeft: '1 spin left',
      noSpins: 'No spins left this week',
      spin: 'Spin',
      spinning: 'Spinning',
      prizeChance: 'Your prize chance: {pct}',
      prizes: 'In the wheel',
      left: '{n} left',
      gone: 'Gone',
      history: 'Your spins',
      winners: 'Winners wall',
      winnersEmpty: 'Winners show up here with their prize.',
      won: 'You won {prize}',
      nothing: 'Not this time',
      nothingBody: 'The wheel opens again next Saturday. More tickets mean better odds.',
      claim: 'Add delivery details',
      again: 'Spin again',
      close: 'Close',
      errors: {
        closed: 'The wheel isn’t open right now.',
        no_spins: 'No spins left this week.',
        generic: 'The wheel stuck. Try again.',
      },
    },
    claim: {
      title: 'Where should we send it?',
      name: 'Full name',
      phone: 'Phone',
      city: 'City',
      address: 'Street, building, apartment, postcode',
      submit: 'Save delivery details',
      saved: 'Saved. Support will message you to confirm.',
    },
    draw: {
      title: 'The draw',
      close: 'Close',
      entry: 'See the draw',
      countdown: 'Draw in {d}d {h}h {m}m',
      commitTitle: 'Fairness hash',
      commitBody:
        'This hash was published before the draw. After the draw the secret seed is revealed — anyone can check the winner was fixed in advance.',
      noCommit: 'The fairness hash is published 24 hours before the draw.',
      live: 'Drawing now',
      winner: 'The winner',
      ticket: 'Ticket {code}',
      verify: 'Verify fairness',
      verifying: 'Checking',
      verified: 'Verified: the hash matches the seed and the same winner comes out.',
      notVerified: 'The check failed — contact Support.',
      forcedNote: 'Test draw with a pre-set winner — the fairness check is off for this attempt.',
      youWon: 'Your ticket came up',
      youWonBody: 'Press the button in the bot chat within 10 minutes to confirm.',
      prize: 'Prize: {prize}',
      seed: 'Seed',
      participants: '{n} tickets in the snapshot',
    },
    vip: {
      title: 'VIP',
      hero: 'The signals land here first',
      members: '{n} members',
      boost: '+{n} tickets the moment you join, ×{x} on everything after.',
      inside: {
        signals: 'A signal every day with entry, target and stop',
        live: 'Two live sessions with Rudy every week',
        lessons: 'Lessons from first trade to risk control',
        chat: 'A private chat with Rudy and the members',
      },
      results: 'Latest results',
      resultsEmpty: 'Results show up here as Rudy posts them.',
      signal: 'Signal of the day',
      entry: 'Entry',
      locked: 'The entry is for members',
      entryMask: 'Buy 00,000 · Target 00,000 · Stop 00,000',
      cta: 'Talk to Support',
      ctaHint: 'Support approves you, then the bot sends you a one-time invite.',
      requested: 'Your code is attached — Support sees where you came from.',
      codeCopied: 'Your code REF-{ref} is copied. If the chat opens empty, paste it and send.',
      supportMissing: 'Support isn’t connected yet. Try again a little later.',
      member: 'You’re in VIP',
      memberBody: 'Your ×{x} multiplier is on. Lessons below pay +1 each.',
      lessons: 'VIP lessons',
      open: 'Open lesson',
      markDone: 'Mark as done',
      done: 'Done',
    },
    tasks: {
      title: 'Tasks',
      onTable: '+{n} tickets on the table',
      rewardLabel: '+{n} tickets',
      allDone: 'All done for now. New tasks drop with every stream and campaign.',
      vipApplied: 'VIP ×{x} already counted in',
      groups: {
        instant: 'Start here',
        social: 'Social',
        live: 'Live',
        daily: 'Daily',
        friends: 'Friends',
        vip: 'VIP',
      },
      state: {
        pending: 'Waiting for review',
        done: 'Done',
        rejected: 'Not approved',
        locked: 'Opens during a stream',
      },
      cta: {
        subscribe: 'Join the channel',
        vip: 'See VIP',
        upload: 'Send screenshot',
        retry: 'Send again',
        code: 'Enter code word',
        quiz: 'Start quiz',
        video: 'Watch',
        guess: 'Make a call',
        invite: 'Invite friends',
        team: 'See team',
        comment: 'Open the channel',
      },
      progress: {
        streak: 'Day {n} of {total}',
        comments: '{n} of {cap} today',
        team: '{n} of {size} ready',
      },
      sheet: {
        close: 'Close',
        handle: 'Your @handle',
        choose: 'Choose screenshot',
        change: 'Change screenshot',
        submit: 'Send for review',
        sending: 'Sending',
        sent: 'Sent. A moderator checks it, usually within a day.',
        follow_instagram:
          'Follow Rudy on Instagram, then screenshot the profile page showing “Following”.',
        follow_tiktok:
          'Follow Rudy on TikTok, then screenshot the profile page showing “Following”.',
        repost_story:
          'Post it to your story with a public profile and keep it up for 24 hours. Screenshot the story.',
        secret_task: 'Do the task below and send a screenshot as proof.',
        hashtag: 'Add {tag} so we find it faster.',
        stream: 'Type the word Rudy says on air. It works for 30 minutes.',
        codePlaceholder: 'Code word',
        codeSubmit: 'Redeem',
        codeOk: '+{n} tickets for {stream}.',
        quizNext: 'Next question',
        quizFinish: 'Finish',
        quizProgress: 'Question {n} of {total}',
        quizResult: '{score} of {total} right. +{n} tickets.',
        quizZero: 'No right answers this time. A new quiz drops soon.',
        videoHint: 'Watch to {pct}% to earn the ticket — the timer runs on our side.',
        videoDone: '+{n} ticket. Thanks for watching.',
        guessTitle: 'Where will {asset} be in {minutes} minutes?',
        guessNow: 'Right now: {price}',
        guessTolerance: 'Land within ±{pct}% to win.',
        guessSubmit: 'Lock my call',
        less: 'Lower',
        more: 'Higher',
        guessLocked: 'Locked at {guess}. We check the price at {time}.',
        guessWon: 'Called it — the price was {actual}. +1 ticket.',
        guessLost: 'The price was {actual}. Try again tomorrow.',
        inviteTitle: 'Your invite link',
        invitedStats: '{invited} invited, {joined} got a ticket',
        copy: 'Copy link',
        copied: 'Copied',
        share: 'Share in Telegram',
        shareText: 'I’m in for the {prize}. Join with my link — we both get closer.',
        teamTitle: 'Your team',
        teamBody:
          'You and your first three friends with a ticket. When all four hold {min}+ tickets, everyone gets +{reward}.',
        teamEmpty: 'Invite friends to fill your team.',
        teamSlot: 'Free seat',
      },
      errors: {
        already_done: 'Already done — the tickets are yours.',
        already_pending: 'Already sent. A moderator is on it.',
        handle_required: 'Add your handle so we can find you.',
        not_an_image: 'That file isn’t an image. Send a screenshot.',
        file_too_large: 'That screenshot is over 10 MB.',
        wrong_code: 'That isn’t today’s code word.',
        window_closed: 'This stream’s window has closed.',
        no_window: 'No stream is live right now.',
        not_open_yet: 'The window hasn’t opened yet.',
        too_early: 'Keep watching — the timer isn’t there yet.',
        not_watched: 'Watch a little more to finish.',
        price_unavailable: 'The price feed is resting. Try again in a minute.',
        generic: 'That didn’t go through. Try again.',
      },
    },
    home: {
      drawIn: 'Draw in {days} days',
      drawInOne: 'Draw tomorrow',
      drawToday: 'Draw today',
      yourTickets: 'Your {n} tickets',
      yourTicketsOne: 'Your 1 ticket',
      noTickets: 'No ticket yet',
      noTicketsBody:
        'Subscribe to the channel and press the button in the bot. Ticket #1 lands here instantly.',
      getFirst: 'Get ticket #1',
      chance: 'Your chance',
      rank: 'Rank',
      inDraw: 'In the draw',
      ticketsLabel: 'Your tickets',
      seasonWeek: 'Week {week} of {weeks}',
      boost: 'Get more tickets',
      boostSoon: 'Tasks open next',
      winners: 'Latest winners',
      winnersEmpty: 'The first wheel spins on Saturday. Winners show up here with their prize.',
      winnersEmptyNoWheel: 'Winners show up here with their prize.',
      ticketLabel: 'Ticket',
      prizeLabel: 'The prize',
    },
    rank: {
      title: 'Season ranking',
      you: 'You',
      leading: 'You lead the season',
      rival: '{n} to pass {name}',
      rivalOne: '1 ticket to pass {name}',
      nextLeague: '{n} to {league}',
      topLeague: 'Top league',
      participants: '{n} in the draw',
      empty: 'Nobody has a ticket yet. Be the first name on this board.',
      leagues: { bronze: 'Bronze', silver: 'Silver', gold: 'Gold' },
      chance: '{pct} chance',
    },
    profile: {
      title: 'Your tickets',
      permanent: 'Permanent',
      permanentHint: 'Channel and VIP tickets stay with you into the next season.',
      season: 'This season',
      history: 'Ticket history',
      empty: 'Every ticket you earn shows up here with where it came from.',
      revoked: 'Removed',
      close: 'Close',
    },
    onboarding: {
      s1Title: 'Every ticket is one chance',
      s1Body:
        'Subscribe for ticket #1. Tasks, friends, streams and VIP add more. The more you hold, the better your odds.',
      s2Title: 'A draw you can check yourself',
      s2Body:
        'A fairness hash is published 24 hours before the draw. Afterwards anyone can recompute the winner from it.',
      s3Title: 'Boost before Saturday',
      s3Body:
        'VIP gives +{vip_reward} instantly and ×{vip_x} on everything after. The weekly wheel opens every Saturday.',
      s3TitleNoWheel: 'Boost your chances',
      s3BodyNoWheel:
        'VIP gives +{vip_reward} instantly and ×{vip_x} on everything after. Every friend you bring adds more.',
      next: 'Next',
      start: 'Open my garage',
      skip: 'Skip',
      hint: 'Swipe or tap to go faster',
      autoStart: 'Your garage opens in a moment',
    },
    reveal: {
      day: 'Day {day} of {total}',
      done: 'Fully revealed',
    },
    share: {
      button: 'Share my card',
      title: 'Your card for stories',
      alt: 'Your share card with your tickets and invite QR',
      rendering: 'Printing your card…',
      story: 'Post to my story',
      chat: 'Send to a friend',
      save: 'Open the image',
      widget: 'Join the giveaway',
    },
    achievements: {
      title: 'Badges',
      count: '{n} of {total}',
      earned: 'Earned',
      first_ticket: 'First ticket',
      first_ticketHint: 'Subscribe to the channel.',
      vip: 'VIP member',
      vipHint: 'Join VIP through Support.',
      streak_7: 'Seven days in a row',
      streakProgress: 'Open the app daily: {n} of 7.',
      friends_5: 'Brought five friends',
      friendsProgress: 'Friends with a ticket: {n} of 5.',
      top_100: 'Top 100',
      top_100Hint: 'Climb into the top 100 of the leaderboard.',
      wheel_prize: 'Wheel winner',
      wheel_prizeHint: 'Win a prize on the Saturday wheel.',
    },
    prefs: {
      title: 'Messages from the bot',
      tips: 'Tips and reminders',
      tipsHint: 'Daily nudges and announcements.',
      rank: 'Leaderboard changes',
      rankHint: 'When you enter or leave the top 100, or someone passes you.',
      wheel: 'Wheel opens',
      wheelHint: 'Saturday wheel opening and the last-hours reminder.',
      always: 'Prize, draw, VIP and subscription messages always arrive.',
    },
    rules: {
      link: 'Rules of the giveaway',
      title: 'Rules of the giveaway',
      howTitle: 'Tickets',
      how: 'Every ticket is one chance in the draw. Channel and VIP tickets are permanent and carry over to the next season; tickets from tasks count for the current season only. Leaving the channel or VIP removes the tickets they gave.',
      drawTitle: 'The draw',
      draw: 'The winner is picked at random, weighted by tickets. A fairness hash is published before the draw and the secret seed right after it, so anyone can recompute the winner. The winner confirms within 10 minutes in the bot chat; otherwise the draw is repeated without them.',
      whoTitle: 'Who can take part',
      who: 'One Telegram account per person. Fake accounts, bought tickets and repeated screenshots are removed.',
      prizeTitle: 'The prize',
      prize:
        'The prize is a gift from Rudy. The winner may take a cash alternative instead. Support contacts the winner in Telegram; we never ask for payment or card details.',
      dataTitle: 'Your data',
      data: 'We store your Telegram id, name and username, your tickets and the delivery details you enter for a prize. Ask Support to delete them at any time.',
    },
    offline: 'You’re offline. Your tickets are safe — we’ll update when the signal is back.',
    errors: {
      auth: 'Open this from the bot in Telegram — we couldn’t confirm who you are.',
      network: 'The connection dropped. Check your signal and try again.',
      retry: 'Try again',
    },
  },
  admin: {
    title: 'Rudy Giveaway admin',
    brand: 'Rudy',
    loading: 'Loading the control room',
    login: {
      heading: 'Sign in to the control room',
      email: 'Email',
      password: 'Password',
      code: 'Code from your authenticator',
      submit: 'Sign in',
      verify: 'Verify code',
      setupHeading: 'Turn on two-step sign-in',
      setupBody:
        'Scan this with Google Authenticator, 1Password or any TOTP app, then enter the 6-digit code it shows.',
      qrAlt: 'QR code for your authenticator app',
      setupSecret: 'Can’t scan? Enter this key by hand:',
      invalidCredentials: 'That email and password don’t match an admin account.',
      invalidCode: 'That code didn’t match. Codes change every 30 seconds — use the current one.',
      attemptsLeft: '{n} attempts left before a 15-minute lock.',
      locked: 'Too many attempts. Sign-in is locked for 15 minutes.',
      setupExpired: 'The setup window closed. Sign in again to get a fresh QR code.',
      network: 'Can’t reach the server. Check your connection and try again.',
    },
    nav: {
      participants: 'Participants',
      audit: 'Audit log',
      season: 'Season',
      settings: 'Settings',
      moderation: 'Moderation',
      tasks: 'Tasks',
      vip: 'VIP',
      wheel: 'Wheel',
      draws: 'Draws',
      testMode: 'Test mode',
      dashboard: 'Dashboard',
      funnel: 'Funnel',
      broadcasts: 'Broadcasts',
      sends: 'Sends',
      links: 'Links',
      conversions: 'Conversions',
      signOut: 'Sign out',
      language: 'Admin language',
    },
    mode: {
      test: 'Test mode. Only testers get messages.',
      live: 'Live. Messages reach everyone.',
    },
    participants: {
      title: 'Participants',
      count: '{n} people',
      search: 'Name, @username or Telegram id',
      allSources: 'All sources',
      organic: 'Organic',
      filters: {
        all: 'Everyone',
        vip: 'VIP',
        shortlist: 'Shortlist',
        testers: 'Testers',
        shadow: 'Shadow users',
        blocked: 'Blocked the bot',
        banned: 'Banned',
      },
      sortTickets: 'Sorted by most tickets',
      sortRecent: 'Sorted by newest',
      columns: {
        person: 'Person',
        tgId: 'Telegram id',
        source: 'Source',
        tickets: 'Tickets',
        status: 'Status',
        joined: 'Joined',
      },
      badges: {
        vip: 'VIP',
        shortlist: 'Shortlist',
        tester: 'Tester',
        shadow: 'Shadow',
        blocked: 'Blocked bot',
        banned: 'Banned',
        unsubscribed: 'Not in the channel',
      },
      empty: 'No one matches these filters. Clear the search or pick another source.',
      prev: 'Previous',
      next: 'Next',
      page: 'Page {page} of {pages}',
    },
    drawer: {
      close: 'Close',
      tickets: 'tickets',
      rank: 'Rank #{rank} of {participants}',
      unranked: 'Not ranked yet',
      permanent: '{n} permanent',
      inSeason: '{n} this season',
      ledger: 'Ticket ledger',
      ledgerEmpty: 'No tickets yet. They appear here the moment one is issued.',
      pushes: 'Messages',
      pushesEmpty: 'Nothing sent to this person yet.',
      referrals: 'Referrals',
      invitedBy: 'Invited by {name}',
      invitedNone: 'Hasn’t invited anyone yet.',
      notes: 'Notes',
      notesSave: 'Save notes',
      notesSaved: 'Notes saved',
      adjust: 'Adjust tickets',
      amount: 'Amount',
      reason: 'Reason (shown in their ledger)',
      permanentToggle: 'Permanent — survives season end',
      addTickets: 'Add tickets',
      removeTickets: 'Remove tickets',
      adjusted: 'Ledger updated',
      message: 'Send a message',
      messagePlaceholder: 'Goes to their Telegram chat with the bot',
      messageSend: 'Send message',
      messageQueued: 'Message queued',
      ban: 'Ban',
      unban: 'Lift ban',
      delete: 'Delete participant',
      deleteConfirm:
        'Delete {name} for good? All their tickets, answers, referrals and message history go too. This can’t be undone. If they press /start again, they join as a new participant.',
      deleteWinner: 'A draw winner can’t be deleted (draw {draws}). Ban them if needed.',
      deleteInDraw:
        'This participant is in finished draw {draws}: deleting would break its fairness proof. If it was a rehearsal, delete the draw first; otherwise ban them.',
      makeTester: 'Make tester',
      addShortlist: 'Add to shortlist',
      removeShortlist: 'Remove from shortlist',
      removeTester: 'Remove tester',
      access: {
        heading: 'Admin panel access',
        none: 'No access to the admin panel.',
        role: 'Role in the admin panel',
        make: 'Make admin',
        remove: 'Remove from admin panel',
        removeConfirm: 'Remove admin panel access? It stops working within 15 minutes.',
        credentials:
          'Send these to the person. Login: {login}, password: {password}. The password is shown once.',
        code: 'Ask for a code from an authenticator app at sign-in',
        codeHint:
          'On their next sign-in they link an authenticator app (Google Authenticator or similar).',
        copy: 'Copy login and password',
      },
      source: 'Source',
      joined: 'Joined',
      lastOpen: 'Last app open',
      never: 'Never',
      pushStatus: {
        queued: 'queued',
        sent: 'sent',
        delivered_shadow: 'logged (shadow)',
        skipped: 'skipped',
        failed: 'failed',
        blocked: 'blocked the bot',
      },
    },
    pushes: {
      title: 'Sends',
      body: 'Every bot message: to whom, when, which step or broadcast and how it ended. Days and times in the season time zone ({tz}). Refreshes every 30 seconds.',
      today: 'Today',
      yesterday: 'Yesterday',
      problems: 'not delivered: {n}',
      whyTitle: 'Why not sent or waiting',
      clearStatus: 'Show all, not only “{status}”',
      status: {
        sent: 'Delivered',
        delivered_shadow: 'Test participant',
        queued: 'Waiting',
        skipped: 'Skipped',
        failed: 'Error',
        blocked: 'Blocked the bot',
      },
      groups: {
        all: 'All',
        funnel: 'Funnel',
        broadcast: 'Broadcasts',
        other: 'Other',
      },
      columns: {
        time: 'Time',
        who: 'To',
        what: 'What',
        status: 'Result',
        details: 'Reason',
      },
      stepStart: 'Funnel: day {n}, {time}',
      stepAfter: 'Funnel: {time} after start',
      stepDraw: 'Funnel: {n} days before the draw, {time}',
      broadcast: 'Broadcast “{title}”',
      kinds: {
        test_send: 'Test to me',
        admin_message: 'Message from admin',
        on_task_approved: 'Task approved',
        on_task_rejected: 'Task rejected',
        on_vip_approved: 'VIP access',
        on_secret_task: 'Secret task',
        on_bonus_spin: 'Bonus spin',
        on_draw_winner_you: 'Draw win',
        on_wheel_open: 'Wheel open',
        on_wheel_reminder: 'Wheel reminder',
      },
      reasons: {
        condition: 'Step condition did not match (e.g. already in VIP or already has a ticket)',
        step_disabled: 'Step switched off or deleted',
        bad_condition: 'Broken step condition',
        opted_out: 'The person switched these messages off in the app',
        no_user_or_season: 'No participant or no active season',
        blocked: 'The person blocked the bot',
        deactivated: 'Telegram account deleted',
        stale: 'Missed its time, too late to send',
        test_mode_non_tester: 'Test mode: only testers receive messages',
        wait_quiet_hours: 'Waits for the morning: quiet hours 23:00–09:00',
        wait_frequency_cap: 'Waits for tomorrow: already 2 messages today',
      },
      noName: 'No name',
      withMedia: 'With picture or video',
      clicked: 'Pressed a button',
      inQueue: 'In the queue',
      empty: 'No sends on this day.',
      more: 'Show more',
    },
    audit: {
      title: 'Audit log',
      empty: 'No admin actions recorded yet.',
      more: 'Load older',
      columns: { when: 'When', who: 'Who', action: 'Action', target: 'Target', details: 'Details' },
    },
    season: {
      title: 'Season',
      modeHeading: 'Delivery mode',
      testBody:
        'Test mode prefixes every message with [TEST] and delivers only to testers. Shadow users are logged, never messaged.',
      liveBody: 'Live mode sends funnel steps, pushes and draw announcements to every participant.',
      goLive: 'Go live',
      backToTest: 'Switch back to test mode',
      confirmLabel: 'Type the season name to confirm: {name}',
      ownerOnly: 'Only the owner can do this.',
      switched: 'Mode changed',
      noneActive: 'No season is running',
      details: 'Season details',
      name: 'Season name',
      prize: 'Prize',
      startsAt: 'Starts',
      tzHint: 'Start, end and the draw above are on this time zone.',
      endsAt: 'Ends',
      drawAt: 'Final draw',
      tz: 'Time zone',
      startBonus: 'VIP start bonus, tickets',
      startBonusHint: 'Given to every VIP member when the season starts.',
      revealMode: 'Car reveal on the Garage counts from',
      revealSeason: 'The season dates: opens from start to end, full on the last day',
      revealPersonal: 'Each person’s first day in the bot',
      revealDays: 'Days until the full photo (from each person’s first day)',
      revealHint: 'Day 1 shows the front of the car; the full photo appears on the last day.',
      prizeImage: 'Prize photo path',
      prizeImageHint: 'For example /app/assets/tesla-hero.jpg (shown on the Garage).',
      save: 'Save details',
      endTitle: 'End of season',
      burnPreview:
        '{burn} season tickets will burn for {users} people. {remain} permanent tickets (channel and VIP) stay for the next season.',
      endBody:
        'Ending burns the season tickets in the ledger and closes the season. Nobody is removed from the channels. Run the final draw first.',
      end: 'End the season',
      ended: 'Season ended: {burned} tickets burned for {users} people.',
      reopenTitle: 'Ended by mistake?',
      reopenBody:
        '{name} is ended. Reopening makes it the running season again and gives back the tickets that burned; participants keep their progress.',
      reopen: 'Reopen the season',
      nextTitle: 'Next season',
      nextBody:
        'Prepare the next prize while this one runs. Tasks, rewards and the funnel are copied from the current season; the new season starts in test mode.',
      draft: 'Draft',
      start: 'Start this season',
      endFirst: 'End the running season before starting the next one.',
      started: 'Season started. {n} VIP members got the start bonus.',
      create: 'Prepare a new season',
      createButton: 'Create draft',
    },
    wheelAdmin: {
      title: 'Wheel',
      week: 'Week {n}',
      shown: 'The wheel is shown in the app',
      hidden: 'The wheel is hidden',
      shownBody: 'Participants see the Wheel tab and get the "wheel is open" pushes.',
      hiddenBody:
        'Nobody sees the wheel: a Support button takes its place in the app, wheel pushes are not sent and spins are refused.',
      show: 'Show the wheel',
      hide: 'Hide the wheel',
      sectors: 'Sectors',
      sectorsBody:
        'Weights are relative. Prize sectors get more likely with more tickets; stock 0 switches a sector off.',
      label: 'Label',
      kind: 'Kind',
      kinds: { physical: 'Physical prize', cash: 'Cash', tickets: 'Tickets', nothing: 'Nothing' },
      value: 'Value',
      weight: 'Weight',
      stock: 'Stock',
      unlimited: 'Unlimited',
      photo: 'Photo',
      photoUpload: 'Upload',
      photoUploading: 'Uploading…',
      photoRemove: 'Remove',
      photoNone: 'none',
      photoDefault: 'Default photo (upload your own to replace it)',
      photoSaveFirst: 'Save sectors first',
      addSector: 'Add sector',
      save: 'Save sectors',
      preview: 'Odds preview',
      previewBody: 'Chance to land any prize for a person holding this many tickets.',
      tickets: '{n} tickets',
      spins: 'Recent spins',
      claims: 'Prizes to deliver',
      claimEmpty: 'Nothing to deliver yet.',
      claimStatuses: {
        awaiting_address: 'Waiting for address',
        address_received: 'Address received',
        shipped: 'Shipped',
      },
      shipped: 'Mark as shipped',
      bonus: 'Give a bonus spin',
      bonusUser: 'Participant id',
      giveBonus: 'Give spin',
      scarcity: 'Scarcity glow on the last physical prizes',
      opensAt: 'Opens',
      closesAt: 'Closes',
      saveSchedule: 'Save schedule',
      wall: 'Winners wall',
      wallName: 'Name',
      wallCity: 'City',
      wallPrize: 'Prize',
      wallMedia: 'Photo URL',
      addWinner: 'Add to the wall',
    },
    drawsAdmin: {
      title: 'Draws',
      create: 'New draw',
      type: 'Type',
      types: { final: 'Final (the car)', extra: 'Extra draw' },
      drawTitle: 'Title',
      prize: 'Prize',
      scheduledAt: 'Scheduled for',
      weighting: 'Weighting',
      weightings: { tickets: 'By tickets', equal: 'One chance each' },
      eligibility: 'Who can win',
      activeToday: 'Opened the app today',
      vipOnly: 'VIP only',
      shortlistOnly: 'Shortlist only',
      minTickets: 'At least {n} tickets',
      minTicketsLabel: 'Minimum tickets',
      joinedBefore: 'Joined before {date}',
      joinedBeforeLabel: 'Joined before',
      includeShadow: 'Include shadow users',
      everyone: 'Everyone with a ticket',
      eligibilityHint:
        'Nothing ticked means everyone with a ticket takes part. Each box narrows it down: a person has to match every ticked condition.',
      vipOnlyHint: 'Only people who joined the VIP channel.',
      shortlistOnlyHint:
        'Only people you added from their profile (Participants → profile → “Add to shortlist”).',
      activeTodayHint: 'Only people who opened the app today. Handy for a live draw among viewers.',
      optional: 'Optional',
      reach: 'Right now {people} people match, holding {tickets} tickets.',
      nobody:
        'Nobody matches these conditions right now. The draw cannot run — loosen them: untick boxes or lower the minimum tickets.',
      nobodyFix:
        'Cancel this draw and create a new one with fewer conditions (or add people to the shortlist).',
      errors: {
        empty_snapshot:
          'Nobody matches this draw’s conditions, so it cannot run. Cancel it and create a new one with fewer boxes ticked.',
        bad_status: 'This step is already done or the draw was cancelled. Refresh the page.',
        no_active_season: 'No active season. Reopen or start a season first.',
        forced_live_season: 'You can only pick a winner in test mode.',
      },
      createDraw: 'Create draw',
      statuses: {
        scheduled: 'Scheduled',
        committed: 'Committed',
        drawing: 'Drawing',
        awaiting_winner: 'Waiting for winner',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
      commit: 'Commit (publish hash)',
      commitBody:
        'Freezes the ticket snapshot and publishes the hash. Do this 24 hours before the draw.',
      channelPost: 'Channel post',
      run: 'Run the draw',
      redraw: 'Redraw',
      redrawConfirm:
        'Redraw? The current winner loses the prize and another ticket is picked. This can’t be undone.',
      cancel: 'Cancel draw',
      cancelConfirm: 'Cancel this draw? Participants stop seeing it.',
      remove: 'Delete draw',
      photo: 'Photo for the winner',
      photoHint:
        'The bot sends it to the winner with the confirmation once they tap “I’m here”. Handy to show on stream.',
      photoUpload: 'Upload photo',
      photoReplace: 'Replace photo',
      photoRemove: 'Remove photo',
      photoUploading: 'Uploading…',
      removeConfirm:
        'Delete this draw? The winner disappears from the app. The record stays in the audit log.',
      dryRun: 'Dry run',
      dryResult: 'Would win: {name}, ticket {index} of {total}',
      stage: 'Open stage for OBS',
      verify: 'Verify page',
      attempts: 'Attempts',
      attempt: 'Attempt {n}',
      responded: 'Confirmed {time}',
      timedOut: 'No answer — timed out',
      waiting: 'Waiting until {time}',
      forced: 'Forced',
      forceWinner: 'Force winner (test mode)',
      forceWinnerHint: 'Participant id of a tester or shadow user. The stage runs exactly as live.',
      saveForce: 'Save forced winner',
      outcome: 'Prize outcome',
      outcomes: { car: 'Car', cash_alternative: 'Cash alternative', declined: 'Declined' },
      empty: 'No draws yet. Create the final draw for this season.',
      snapshot: '{n} tickets in the snapshot',
    },
    dashboard: {
      title: 'Dashboard',
      participants: 'Participants',
      participantsNote: '{blocked} blocked the bot',
      ticketsToday: 'Tickets issued today',
      ticketsTotal: 'Tickets in play',
      vipJoins: 'VIP members',
      vipToday: '+{n} today',
      activeToday: 'Opened the app today',
      pushesToday: 'Messages sent today',
      pending: 'Waiting for moderation',
      next: 'Coming up',
      nextWheel: 'Wheel opens {when}',
      nextWheelOpen: 'Wheel is open until {when}',
      nextDraw: '{title} — {when}',
      noDraw: 'No draw scheduled',
      nextFunnel: '{n} funnel messages due in the next 24 h',
      funnelTitle: 'From link to VIP',
      funnelBody: 'Everyone who started the bot, all sources. Shares are of the step before.',
      stageJoined: 'Started the bot',
      stageSubscribed: 'Subscribed to the channel',
      stageOpened: 'Opened the app',
      stageVip: 'Joined VIP',
      ofPrevious: '{pct} of the step before',
      ofJoined: '{pct} of everyone who came',
      sourcesTitle: 'Sources',
      sourcesBody: 'Conversion to VIP is the number the ads are judged by.',
      organic: 'Organic (no link)',
      colSource: 'Source',
      colClicks: 'Clicks',
      colJoined: 'Started',
      colSubscribed: 'Subscribed',
      colOpened: 'App',
      colVip: 'VIP',
      colVipRate: 'To VIP',
      heatTitle: 'When people collect tickets',
      heatBody: 'Ticket awards by weekday and hour, last 28 days, {tz}.',
      heatCell: '{day} {hour}:00 — {n} awards',
      heatLess: 'Fewer',
      heatMore: 'More',
      days: 'Mon,Tue,Wed,Thu,Fri,Sat,Sun',
      cohortsTitle: 'Cohorts by first week',
      colWeek: 'Week of',
      colAvg: 'Avg tickets',
      exports: 'Export CSV',
      exportParticipants: 'Participants',
      exportWinners: 'Winners with addresses',
      exportLedger: 'Ticket ledger',
      empty: 'Nothing yet — numbers appear as soon as the first people start the bot.',
    },
    funnel: {
      intro: {
        title: 'Start of the funnel',
        body: 'Every newcomer gets these two messages before the day-by-day steps. Tokens: {tokens}.',
        welcomeTitle: 'After /start: join the channel',
        welcomeBody:
          'The first message after the person presses Start, with the Open the channel and I subscribed buttons. Attach a picture, video, circle or voice here.',
        ticketTitle: 'After I subscribed: ticket #1',
        ticketBody:
          'Sent once the bot has checked the subscription and issued the first ticket. The steps below run from here.',
        resetText: 'Restore the default text',
        save: 'Save the start of the funnel',
        saved: 'Saved. New people get this within seconds.',
        next: 'Then the day-by-day steps below: day 0 counts from pressing Start.',
      },
      title: 'Funnel',
      body: 'Personal messages on day N after someone starts the bot, then a countdown to the final draw for everyone. Times are {tz}. Changes apply from the next minute; a queued message always goes out with the latest text.',
      rules: 'Delivery rules',
      quietFrom: 'Quiet from',
      quietTo: 'Quiet until',
      cap: 'Max messages per person per day',
      capHint: 'Prize and draw messages ignore the limit.',
      saveRules: 'Save rules',
      myTg: 'Your Telegram id (for test sends)',
      myTgHint: 'Press /start in the bot with this account first.',
      saveMyTg: 'Save id',
      steps: 'Steps',
      addStep: 'New step',
      colDay: 'Day',
      colTime: 'Time',
      colWho: 'Sent when',
      colMessage: 'Message',
      colDue: 'Next 24 h',
      colSent: 'Sent',
      colDelivered: 'Delivered',
      colClicked: 'Clicked',
      dayN: 'Day {n}',
      beforeDraw: '{n} days before the draw',
      dayBeforeDraw: 'The day before the draw',
      drawDay: 'Draw day',
      anchor: 'Counted from',
      anchorStart: 'The day the person started the bot',
      anchorDraw: 'The final draw (same moment for everyone)',
      daysBefore: 'Days before the draw',
      reset: 'Reset to default funnel',
      resetConfirm:
        'This replaces every step of this season with the default funnel. Type reset to confirm.',
      resetDone: 'Funnel reset: {n} default steps.',
      afterStart: '{time} after start',
      variant: '{v} · {pct} %',
      off: 'Off',
      edit: 'Edit step',
      create: 'New step',
      dayOffset: 'Day after start',
      sendTime: 'Time',
      sendTimeHint: '12:00 = that day at 12:00. +02:00 = two hours after they started.',
      condition: 'Send only when',
      conditionHint: 'Facts: {facts}. Combine with && || ! and compare, e.g. tickets < 5.',
      variantLabel: 'Variant',
      split: 'Share of people, %',
      template: 'Message',
      templateHint: 'Tokens: {tokens}',
      buttons: 'Buttons',
      addButton: 'Add button',
      removeButton: 'Remove',
      buttonLabel: 'Label',
      buttonAction: 'Opens',
      enabled: 'Enabled',
      save: 'Save step',
      saved: 'Saved. The next tick uses it.',
      remove: 'Delete step',
      removeConfirm: 'Delete this step? Queued messages for it will be skipped.',
      addVariant: 'Add variant B',
      test: 'Send test to me',
      testSent: 'Sent to your Telegram.',
      media: {
        title: 'Attachment',
        none: 'Text only',
        kinds: {
          video_note: 'Video note',
          voice: 'Voice',
          video: 'Video',
          photo: 'Picture',
        },
        hint: {
          video_note:
            'A round video. Record it in Telegram and send it to the bot, or upload a square MP4 up to 1 minute.',
          voice:
            'A voice message. Record it in Telegram and send it to the bot, or upload OGG / MP3.',
          video: 'A video with the text as its caption. MP4 up to 50 MB.',
          photo: 'A picture with the text as its caption. JPG, PNG or WebP.',
        },
        empty: 'Nothing of this type in the library yet.',
        upload: 'Upload from computer',
        linkTitle: 'Link your Telegram to upload files',
        linkBody:
          'The bot sends the file to your own chat once so Telegram keeps it, then deletes that message. Press the button, press Start in the bot, and the upload carries on by itself.',
        linkButton: 'Link Telegram',
        uploading: 'Uploading…',
        refresh: 'Refresh list',
        delete: 'Delete from the library',
        deleteConfirm: 'Delete “{title}” from the media library? This cannot be undone.',
        viaBot:
          'From your phone: send the file to the bot from the Telegram linked to your admin account, then press Refresh list.',
        circleNote:
          'A video note cannot carry text: the text and buttons arrive as the next message.',
      },
      preview: 'Preview',
      previewFor: 'Filled in for {name}',
      matches: 'This person would get it now.',
      notMatches: 'This person would not get it now.',
      close: 'Close',
      empty: 'No steps yet.',
      everyone: 'everyone',
      nobody: 'nobody',
      conditionBroken: '— the condition has a mistake, see below',
      readsAs: 'Reads as: {text}',
      and: 'and',
      or: 'or',
      not: 'not',
      facts: {
        tickets: 'tickets',
        has_ticket: 'has a ticket',
        no_ticket: 'no ticket yet',
        has_vip: 'in VIP',
        opened_app: 'opened the app',
        no_app_open_days: 'days without opening the app',
        referral_sent: 'invited a friend',
        not_spun_this_week: "hasn't spun the wheel this week",
        is_saturday_or_next: 'wheel open or opening within 24 h',
        streak_days: 'days in a row in the app',
        rank: 'rank',
        source: 'source',
        is_tester: 'tester',
        reveal_day: 'car reveal day',
      },
      actions: {
        open_app: 'Mini App — Garage',
        'open_app:tasks': 'Mini App — Tasks',
        'open_app:rank': 'Mini App — Rank',
        'open_app:wheel': 'Mini App — Wheel',
        'open_app:vip': 'Mini App — VIP',
        'open_app:draw': 'Mini App — Draw',
        'open_app:friends': 'Mini App — Invite friends',
        support_link: 'Support chat (with REF code)',
        channel_link: 'Main channel',
        check_subscribe: 'Subscription check',
      },
    },
    broadcasts: {
      title: 'Broadcasts',
      body: 'A one-off message to everyone who matches a condition. Delivery follows the daily limit and quiet hours.',
      compose: 'New broadcast',
      name: 'Name (only admins see it)',
      segment: 'Send to people where',
      segmentHint: 'Leave true for everyone. Same facts as the funnel.',
      estimate: 'Count people',
      estimateResult: 'Matches {n} people right now',
      saveDraft: 'Save draft',
      sendNow: 'Send now',
      sendConfirm: 'Send "{title}" to everyone in the segment now?',
      scheduleAt: 'Send at',
      schedule: 'Schedule',
      cancel: 'Cancel',
      list: 'All broadcasts',
      empty: 'No broadcasts yet.',
      statuses: {
        draft: 'Draft',
        scheduled: 'Scheduled',
        sending: 'Sending',
        done: 'Sent',
        cancelled: 'Cancelled',
      },
      progress: '{sent} of {target} delivered',
      waiting: '{n} waiting for the limit or quiet hours',
      clicked: '{n} opened the app',
      skippedFailed: '{n} not delivered',
      scheduledFor: 'Goes out {when}',
      problems: 'Delivery problems',
      problemsBody:
        'Messages that failed after five attempts (Telegram errors, timeouts). People who blocked the bot are not listed — they are skipped for good.',
      problemsNone: 'No failed messages.',
      stuck:
        '{n} messages are still queued after 36 hours — check that the bot and worker are running (RUNBOOK).',
      retryAll: 'Retry all failed',
      retried: '{n} messages queued again.',
    },
    links: {
      title: 'Links',
      body: 'One link per ad, reel or post. People land on a short page that opens the bot and remembers the click for conversion reporting.',
      build: 'New link',
      utmSource: 'Source',
      utmCampaign: 'Campaign',
      utmAdgroup: 'Ad group',
      utmContent: 'Creative',
      label: 'Note',
      code: 'Code (optional)',
      codeHint: 'Letters, digits, _ and -. Generated from the fields when empty.',
      create: 'Create link',
      list: 'All links',
      bridge: 'Link for ads',
      deepLink: 'Direct bot link',
      copy: 'Copy',
      copied: 'Copied',
      qr: 'QR code',
      downloadQr: 'Download SVG',
      hideQr: 'Hide QR',
      empty: 'No links yet. Create one for each ad so you can compare them.',
    },
    conversions: {
      title: 'Conversions',
      body: 'Report first tickets and VIP joins back to the ad networks so they optimise for people who convert. Keys live in the server .env; switch an adapter on here.',
      tiktok: 'TikTok Events API',
      tiktokBody:
        'First ticket → CompleteRegistration, VIP join → SubmitForm, with the ttclid from the link page.',
      tgbooster: 'TgBooster postback',
      tgboosterBody: 'First ticket and VIP join → postback with the ad hash from the start link.',
      configured: 'Keys set',
      notConfigured: 'Keys missing in .env',
      on: 'Sending',
      offState: 'Off',
      turnOn: 'Turn on',
      turnOff: 'Turn off',
      ownerOnly: 'Only the owner can switch adapters.',
      ping: 'Send test event',
      pingResult: 'Test event: {status}',
      counts: '{sent} sent, {failed} failed',
      log: 'Delivery log',
      empty: 'Nothing sent yet.',
      colTime: 'Time',
      colAdapter: 'Adapter',
      colEvent: 'Event',
      colPerson: 'Person',
      colStatus: 'Status',
      colResponse: 'Response',
      statuses: { pending: 'pending', sent: 'sent', failed: 'failed' },
    },
    testMode: {
      title: 'Test mode',
      body: 'Rehearse every flow on testers and shadow users. Nothing here reaches real participants while the season is in test mode.',
      liveWarning: 'The season is live — scenarios are switched off.',
      target: 'Tester',
      targetHint: 'Participant id of a tester (they must have pressed /start).',
      noResponse: 'Winner doesn’t respond',
      noResponseBody: 'Times out the current winner of the latest draw and redraws.',
      forceSector: 'Wheel: force the next spin of this tester',
      sector: 'Sector',
      unsubscribe: 'Simulate unsubscribe',
      vipJoin: 'Simulate VIP join',
      done: 'Done',
    },
    vipAdmin: {
      title: 'VIP',
      requests: 'Requests',
      requestsBody:
        'People who pressed Talk to Support, with the code from their message. Approve sends them a one-time invite.',
      empty: 'No VIP requests yet.',
      statuses: {
        new: 'New',
        talked: 'Talking',
        approved: 'Approved',
        joined: 'Joined',
        declined: 'Declined',
      },
      waitingJoin: 'Tapped the invite',
      approve: 'Approve and send invite',
      approveNow: 'Approve and let in',
      talked: 'Mark as talking',
      decline: 'Decline',
      revoke: 'Remove from VIP',
      note: 'Note',
      results: 'Results',
      resultsBody:
        'Shown on the VIP screen. The signal of the day shows its result to everyone and its entry only to members.',
      resultTitle: 'Title',
      resultValue: 'Result',
      resultEntry: 'Entry (members only)',
      signalOfDay: 'Signal of the day',
      addResult: 'Add result',
      removeResult: 'Remove result',
      removeResultConfirm: 'Remove this result from the app?',
      lessons: 'Lessons',
      lessonsBody: 'Five lessons members tick off for +1 ticket each.',
      lessonTitle: 'Lesson title',
      lessonUrl: 'Link (channel post or video)',
      saveLessons: 'Save lessons',
      channelMissing: 'Set the VIP channel in Settings first — invites are created there.',
    },
    moderation: {
      title: 'Moderation',
      pending: '{n} waiting',
      empty: 'Queue is clear. New screenshots land here the moment someone sends one.',
      approve: 'Approve',
      reject: 'Reject',
      approveAll: 'Approve all {n}',
      imageMissing: 'The screenshot is missing on the server. Reject and ask for it again.',
      approveAllConfirm:
        'Approve {n} submissions and award their tickets? Ones with repeated screenshots ({skipped}) stay for a manual look.',
      reasonLabel: 'Reason the person will see',
      keys: 'Keys: A to approve, R to reject, J and K to move through the queue.',
      handle: 'Declared handle',
      noHandle: 'No handle given',
      duplicate: 'Same image used by {n} other people',
      duplicateOne: 'Same image used by 1 other person',
      history: '{approved} approved, {rejected} rejected before',
      vip: 'VIP',
      swipeHint: 'Swipe right to approve, left to reject',
      approved: 'Approved, +{n}',
      rejected: 'Rejected',
      reasons: {
        private: 'Profile is private — make it public and send again.',
        notFollowing: 'The screenshot doesn’t show that you follow Rudy.',
        wrongStory: 'This isn’t the campaign story.',
        duplicate: 'This screenshot was already used by another account.',
        unreadable: 'The screenshot is too blurry to check.',
      },
    },
    tasksAdmin: {
      title: 'Tasks',
      catalog: 'Task catalogue',
      catalogBody:
        'Turn tasks on or off and set their reward. VIP ×1.5 is applied on top automatically.',
      reward: 'Reward',
      enabled: 'On',
      vipNote:
        'A new VIP reward applies to people who join VIP from now on; tickets already given stay.',
      streams: 'Live streams',
      streamsBody:
        'Create the stream with its code word, then open the window when you say it on air.',
      streamTitle: 'Stream title',
      codeWord: 'Code word',
      createStream: 'Create stream',
      openWindow: 'Open 30-minute window',
      closeWindow: 'Close window',
      liveUntil: 'Live until {time}',
      closed: 'Closed',
      notOpened: 'Not opened yet',
      campaigns: 'Repost campaigns',
      campaignTitle: 'Campaign name',
      hashtag: 'Hashtag (optional)',
      link: 'Story link (optional)',
      createCampaign: 'Add campaign',
      quizzes: 'Quizzes',
      quizTitle: 'Quiz title',
      quizHelp:
        'One question per block: the question on the first line, then the options. Put * in front of the right one.',
      createQuiz: 'Add quiz',
      videos: 'Videos',
      videoTitle: 'Video title',
      videoUrl: 'Video URL (mp4)',
      videoDuration: 'Length, seconds',
      createVideo: 'Add video',
      secret: 'Secret task',
      secretBody:
        'Shown only after a push. Turning it on notifies every participant once this week.',
      instructions: 'What people must do',
      secretOn: 'Turn on and notify',
      secretOnConfirm: 'Turn on the secret task? Everyone gets a message about it right away.',
      secretOff: 'Turn off',
      notified: '{n} people notified',
      saved: 'Saved',
      active: 'Active',
      paused: 'Paused',
      pause: 'Pause',
      resume: 'Resume',
    },
    settings: {
      title: 'Settings',
      telegramHeading: 'Telegram channels',
      telegramBody:
        'The bot checks subscriptions in the main channel, lets approved people into VIP and counts comments in the discussion group. Add @{bot} as an admin in each one, then check it here.',
      mainChannel: 'Main channel',
      mainChannelHint:
        'Numeric id (-100…) or @username. Private channel? Forward any post to @userinfobot to get its id.',
      mainChannelLink: 'Main channel invite link',
      mainChannelLinkHint:
        'Shown on the "Open the channel" button. Check the channel to fill it in automatically.',
      vipChannel: 'VIP channel',
      discussionGroup: 'Discussion group',
      supportUsername: 'Support: username or chat link',
      supportUsernameHint:
        'Who talks to VIP candidates. @username — the REF code is prefilled. A https://t.me/… link (e.g. a business link t.me/m/…) opens as it is; people paste their copied code.',
      check: 'Check',
      supportMissing:
        'No Support account set: the "Talk to Support" buttons are hidden and people see "Support isn’t connected yet".',
      checking: 'Checking',
      useLink: 'Use this link',
      botAdmin: 'Bot is an admin',
      botNotAdmin: 'Bot is not an admin here yet — add @{bot} as an administrator',
      cannotInvite: 'Bot can’t invite users — turn on "Invite users via link"',
      notFound: 'Telegram doesn’t know this chat, or the bot isn’t in it yet.',
      fromEnv: 'from .env',
      save: 'Save settings',
      saved: 'Saved. The bot picks this up within 10 seconds.',
      media: 'Picture or video in bot messages',
      mediaBody:
        'A picture, video, circle or voice the bot sends with the message. Files come from the media library: upload them or send them to the bot from your Telegram. Text only = no attachment.',
      welcomeVideo: 'Welcome (the first message after /start)',
      ticketVideo: 'Ticket #1 message (after subscribing)',
      saveMedia: 'Save',
      mediaSaved: 'Saved. New people get this attachment.',
      backups: 'Backups',
      backupLatest: 'Last backup {when}, {size}.',
      backupNone: 'No backup yet — the first one runs tonight.',
      backupStale: 'That is more than a day ago: check the backup service.',
      backupBody:
        'A full database dump runs every night and the last 14 are kept on the server. How to restore one is in docs/RUNBOOK.md.',
      team: {
        heading: 'Team',
        body: 'People who can sign in to this admin panel. Give each person their own sign-in: what they do shows under their email in the audit log.',
        roles: {
          owner: 'Owner',
          admin: 'Admin',
          support: 'Support',
        },
        roleHints: {
          owner: 'Everything, including going live, ending the season and the team.',
          admin: 'Everything except going live, ending the season and the team. Can run draws.',
          support:
            'Participants, moderation and VIP requests. Cannot change settings or run draws.',
        },
        you: 'you',
        noCode: 'Has not signed in yet',
        lastLogin: 'Last sign-in {when}',
        email: 'Email',
        role: 'Role',
        add: 'Add to the team',
        passwordFor:
          'Send {email} this password: {password}. It is shown once. On the first sign-in they link an authenticator app (Google Authenticator or similar).',
        copy: 'Copy',
        copied: 'Copied',
        reset: 'Reset sign-in',
        resetConfirm: 'Reset sign-in for {email}? Their password stops working.',
        remove: 'Remove',
        removeConfirm: 'Remove {email} from the team?',
        confirm: 'Yes',
        cancel: 'Cancel',
      },
      testersHeading: 'Testers',
      testersBody:
        'In test mode only testers get messages. Open Participants, find the person (they must press /start first) and choose Make tester.',
    },
    ledger: {
      manual: 'Manual adjustment',
      season_end: 'Season end burn',
      season_start_bonus: 'VIP season bonus',
      wheel_sector_tickets: 'Wheel prize: tickets',
      wheel_streak: 'Wheel streak',
      activity_lottery: 'Activity lottery',
      vip_lesson: 'VIP lesson',
      revoke: 'Revoked',
      channel_subscribe: 'Joined the channel',
      vip_join: 'Entered VIP',
      follow_instagram: 'Instagram follow',
      follow_tiktok: 'TikTok follow',
      repost_story: 'Story repost',
      stream_attend: 'Live stream',
      daily_streak: '7-day streak',
      price_guess: 'Price call',
      quiz: 'Quiz',
      watch_video: 'Watched video',
      comment: 'Comment',
      referral: 'Invited friend',
      team_pool: 'Team',
      secret_task: 'Secret task',
    },
    errors: {
      generic: 'That didn’t work: {message}',
      forbidden: 'Your role can’t do that. Ask the owner.',
      badInput: 'Check the fields: one of the values doesn’t fit.',
      badField: 'Check “{field}”: the value doesn’t fit.',
      codes: {
        media_in_use:
          'This file is still attached to a funnel step, the start of the funnel or an unsent broadcast. Pick another file there first, then delete it.',
        media_not_picked:
          'An attachment type is chosen but no file is picked. Pick a file or choose Text only.',
        bad_path: 'The file path must start with /app/assets/ or https://.',
        chat_not_found:
          'The bot cannot see this channel or chat. Check the id and that the bot is an admin there.',
        confirmation_required: 'The confirmation didn’t match — type the word exactly as shown.',
        in_the_past: 'That time has passed. Pick a time in the future.',
        no_file: 'No file chosen.',
        not_an_image: 'Upload a JPG, PNG or WebP picture.',
        secret_needs_instructions: 'Write what the secret task asks first.',
        telegram_rejected:
          'Telegram did not accept the file. MP4 for video and circles, OGG/MP3 for voice, JPG for pictures.',
        not_found: 'Not found — it may have been deleted. Reload the page.',
        already_done: 'Already done.',
        already_sent: 'This broadcast has already gone out and can’t be changed.',
        already_vip: 'Already in VIP.',
        bad_status: 'Not available right now — reload, the status has changed.',
        bot_not_configured: 'The bot is not connected on the server (no token).',
        code_taken: 'This code is already used. Pick another.',
        email_taken: 'This email already has access.',
        forced_live_season: 'A winner cannot be forced in a live season.',
        no_active_season: 'No active season. Start one in Season.',
        no_wheel: 'No wheel is set up for this week.',
        not_pending: 'This one has already been handled.',
        self: 'You cannot change your own access.',
        shadow: 'Test users cannot get admin access.',
        too_large: 'The file is over 50 MB. Compress it and try again.',
        locked: 'Too many attempts. Wait 15 minutes.',
        telegram_download_failed: 'Telegram did not return the file. Try again.',
        no_admin_tg:
          'Link your Telegram first (Funnel → your Telegram id) and press /start in the bot.',
        not_a_tester: 'Test season: make yourself a tester in Participants.',
        wheel_hidden: 'The wheel is switched off in settings.',
      },
      fields: {
        name: 'Name',
        prizeName: 'Prize',
        prizeImage: 'Prize photo path',
        tz: 'Time zone',
        startsAt: 'Start',
        endsAt: 'End',
        drawAt: 'Final draw',
        startBonusVip: 'VIP start bonus',
        revealDays: 'Days to full reveal',
        sendTime: 'Time',
        dayOffset: 'Day',
        condition: 'Condition',
        template: 'Message text',
        splitPct: 'Share of people',
        label: 'Button text',
        action: 'Button action',
        buttons: 'Buttons',
        quiet: 'Quiet hours',
        from: 'Quiet from',
        to: 'Quiet to',
        cap: 'Daily message cap',
        reward: 'Reward',
        url: 'Link',
        title: 'Title',
        code: 'Link code',
        source: 'Source',
        codeWord: 'Code word',
        question: 'Question',
        options: 'Answer options',
        durationSec: 'Duration',
        minWatchPct: 'Watch share',
        maxReward: 'Max reward',
        mainChannelId: 'Main channel',
        vipChannelId: 'VIP channel',
        discussionGroupId: 'Discussion group',
        mainChannelLink: 'Channel link',
        supportUsername: 'Support',
        welcomeVideo: 'Welcome video',
        ticketVideo: 'Ticket video',
        prize: 'Prize',
        scheduledAt: 'Draw time',
        text: 'Text',
        at: 'Send time',
        email: 'Email',
        fileId: 'File',
        instructions: 'Instructions',
      },
      step: {
        unknownFact: 'Unknown word “{x}” in the condition. Use the data listed under the field.',
        unknownToken: 'Unknown token “{x}” in the text. Use the tokens listed under the field.',
        unknownFunction: 'Unknown function {x}() in the condition.',
        unexpected: 'Unexpected “{x}” in the condition.',
        expected: 'The condition is missing “{x}”.',
        unexpectedEnd: 'The condition ends too early.',
        isList: '“{x}” is a list and can’t be compared directly.',
        emptyMessage: 'The message is empty.',
      },
      seasonDates:
        'Check the dates: the end must be after the start, and the final draw can’t be before the start.',
    },
  },
} as const;

export type Copy = typeof en;
